import { ManagementFileRepository } from '@domain/management-file/repositories/management-file.repository';
import { ManagementFileRepositoryService } from '../repositories/management-file.service';

export const ManagementFileProvider = [
    {
        provide: ManagementFileRepository,
        useClass: ManagementFileRepositoryService,
    },
];